export const servicesOrder = { DINE_IN: 0, PICKUP: 1, CURBSIDE: 2, DELIVERY: 3 };
